<template>
  <div class="d-flex">
    <v-icon
      id="ware-select-info-btn"
      :disabled="!ware"
      :color="ware ? 'secondary' : null"
      v-if="showInfo"
      @click="showInfoDialog"
      class="ml-2 pa-2"
      >fa-info-circle</v-icon
    >
    <v-autocomplete
      id="ware-select-autocomplete"
      :menu-props="{ bottom: true, offsetY: true }"
      class="rounded-lg ware-select-autocomplete"
      :title="ware && ware.name"
      :label="label"
      :items="items"
      v-model="ware"
      :item-text="itemText"
      :clearable="clearable"
      item-value="id"
      :multiple="multiple"
      :disabled="disabled"
      :return-object="true"
      :suffix="getSuffix()"
      v-bind="$attrs"
      v-on="$listeners"
      :smaller-font="ware && ware.name.length > 30"
    ></v-autocomplete>

    <v-dialog v-if="ware" v-model="infoDialog" width="70%">
      <v-card>
        <v-row>
          <v-col cols="12">
            <v-tabs
              class="rounded-lg white--text"
              background-color="secondary"
              active-class="primary"
              color="#FF8700"
              v-model="activeTab"
            >
              <v-tab class="white--text mr-5">
                <span>موجودی کالا</span>
              </v-tab>
              <v-tab class="white--text" @click="showSalePrices">
                <span>آخرین قیمت فروش</span>
              </v-tab>
              <v-tab class="white--text" @click="showBuyPrices">
                <span>آخرین قیمت خرید</span>
              </v-tab>
              <v-tab class="white--text">
                <span>کاردکس کالا</span>
              </v-tab>
              <v-tab
                @click="setPrices"
                class="white--text"
                v-if="this.hasSalePrices == true && this.ware && this.account"
              >
                <span>آخرین قیمت های {{ ware.name }} برای {{ account.name }}</span>
              </v-tab>

              <v-tab-item class="pt-4">
                <v-card class="white rounded-lg">
                  <v-card-title class="secondary--text">
                    <v-avatar class="ml-3" size="30" color="primary">
                      <v-img max-width="20" max-height="20" src="/img/icons/warehouse.svg"></v-img>
                    </v-avatar>
                    موجودی انبار ها برای {{ ware.name }}
                  </v-card-title>
                  <v-card-text>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>انبار</th>
                          <th>مانده</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-if="inventories.length != 0">
                          <tr v-for="(inventory, i) in inventories" :key="inventory.id">
                            <td>{{ i + 1 }}</td>
                            <td>{{ inventory.warehouse.title }}</td>
                            <td>{{ inventory.count | toMoney }}</td>
                          </tr>
                        </template>
                        <tr v-else>
                          <td colspan="3" class="font-weight-bold error--text">
                            موجودی کالای {{ ware.name }} صفر می باشد
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item class="pt-4">
                <v-card class="white rounded-lg pa-5">
                  <v-card-title class="secondary--text">آخرین قیمت های فروش {{ ware.name }}</v-card-title>

                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <m-datatable
                          :headers="sellPricesHeaders"
                          api-url="reports/buySale"
                          :filters.sync="pricesFilters"
                          :show-filter-row="false"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item class="pt-4">
                <v-card class="rounded-lg white pa-5">
                  <v-card-title class="secondary--text">آخرین قیمت های خرید {{ ware.name }}</v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <m-datatable
                          :headers="buyPricesHeaders"
                          api-url="reports/buySale"
                          :filters.sync="pricesFilters"
                          :show-filter-row="false"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item class="pt-4">
                <v-card class="white rounded-lg pa-5">
                  <detailed-ware-inventory :passed_ware="ware"></detailed-ware-inventory>
                </v-card>
              </v-tab-item>
              <v-tab-item class="pt-4" v-if="this.hasSalePrices && this.ware && this.account">
                <v-card class="rounded-lg white pa-5">
                  <v-card-title class="secondary--text"
                    >آخرین قیمت های {{ ware.name }} برای {{ account.name }}</v-card-title
                  >
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <m-datatable
                          :headers="pricesHeaders"
                          api-url="reports/buySale"
                          :filters.sync="pricesFilters"
                          :item-per-page="5"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import wareApiMixin from "@/mixin/wareApi";
import OpenInventoryBtn from "@/components/btns/OpenInventoryBtn.vue";
import DetailedWareInventory from "@/views/panel/inventory/ware/DetailedWareInventory";

export default {
  mixins: [wareApiMixin],
  components: { DetailedWareInventory, OpenInventoryBtn },
  props: {
    value: {},
    disabled: {},
    label: {},
    withCode : {
      default: false,
    },
    multiple : {
      default: false,
    },
    returnObject: {
      default: true,
    },
    clearable: {
      default: false,
    },
    factorType: {
      default: null,
    },
    showMainUnit: {
      default: true,
    },
    isService: {
      default: false,
    },
    showInfo: {
      default: true,
    },
    hasSalePrices: {
      default: false,
    },
    account: {
      default: null,
    },
    floatAccount: {
      default: null,
    },
    costCenter: {
      default: null,
    },
  },
  data() {
    return {
      ware: null,
      infoDialog: false,
      activeTab: 0,
      wareInventory: [],
      buyPricesHeaders: [
        {
          text: "شماره فاکتور",
          value: "factor.code",
        },
        {
          text: "تاریخ",
          value: "factor.date",
          type: "date",
        },
        {
          text: "تعداد",
          value: "count",
          type: "numeric",
        },
        {
          text: "واحد",
          value: "unit.name",
        },
        {
          text: "خریدار",
          value: "factor.account.name",
          type: "text",
        },
        {
          text: "فی",
          value: "fee",
          type: "numeric",
          sortable: false,
        },
        {
          text: "مبلغ کل",
          value: "total_value",
          type: "numeric",
          sortable: false,
        },
      ],
      pricesHeaders: [
        {
          text: "شماره فاکتور",
          value: "factor.code",
        },
        {
          text: "تاریخ",
          value: "factor.date",
          type: "date",
        },
        {
          text: "تعداد",
          value: "count",
          type: "numeric",
        },
        {
          text: "واحد",
          value: "unit.name",
        },
        {
          text: "فی",
          value: "fee",
          type: "numeric",
          sortable: false,
        },
        {
          text: "مبلغ کل",
          value: "total_value",
          type: "numeric",
          sortable: false,
        },
      ],

      sellPricesHeaders: [
        {
          text: "شماره فاکتور",
          value: "factor.code",
        },
        {
          text: "تاریخ",
          value: "factor.date",
          type: "date",
        },
        {
          text: "تعداد",
          value: "count",
          type: "numeric",
        },
        {
          text: "واحد",
          value: "unit.name",
        },
        {
          text: "فروشنده",
          value: "factor.account.name",
          type: "text",
        },
        {
          text: "فی",
          value: "fee",
          type: "numeric",
          sortable: false,
        },
        {
          text: "مبلغ کل",
          value: "total_value",
          type: "numeric",
          sortable: false,
        },
      ],
      pricesFilters: {
        offset: 0,
        limit: 5,
        ware: null,
        factor__type__in: null,
        factor__account: null,
        factor__floatAccount: null,
      },
    };
  },
  computed: {
    itemText() {
      if (this.withCode) {
        return 'code'
      } else {
        return 'name'
      }
    },
    items() {
      return this.wares.filter((o) => {
        if (o.level != 3) return false;
        if ([true, false].includes(this.isService)) return o.is_service == this.isService;
        return true;
      });
    },
    inventories() {
      let inventories = this.wareInventory.reduce((v, inventory) => {
        let member = v.filter((o) => o.warehouse.id == inventory.warehouse.id);
        if (member.length) {
          member = member[0];
          member.count += +inventory.count;
        } else {
          v.push({
            warehouse: inventory.warehouse,
            count: +inventory.count,
          });
        }
        return v;
      }, []);

      return inventories.sort((a, b) => a.warehouse.id - b.warehouse.id);
    },
  },
  created() {
    this.getWares();
    this.setWare();
  },
  methods: {
    filterObject(item, queryText, itemText) {
      return (
        itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
        (item.barcode && item.barcode.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1)
      );
    },
    showInfoDialog() {
      this.request({
        url: this.endpoint(`wares/wares/${this.ware.id}`),
        method: "get",
        success: (data) => {
          this.wareInventory = data.inventory;
        },
      });
      this.activeTab = 0;
      this.infoDialog = true;
    },
    showBuyPrices() {
      this.pricesFilters.factor__type__in = "buy";
      this.pricesFilters.ware = this.ware.id;
    },
    showSalePrices() {
      this.pricesFilters.factor__type__in = "sale";
      this.pricesFilters.ware = this.ware.id;
    },
    setWare() {
      if (this.value != this.ware) {
        if (isNaN(this.value)) {
          this.ware = this.value;
        } else {
          this.ware = this.wares.find((o) => o.id == this.value);
          this.$emit("input", this.ware);
          this.$emit("mainUnitName", this.ware.main_unit_name);
        }
        if (this.ware) {
          this.pricesFilters.ware = this.ware.id;
        }
      }
    },
    getSuffix() {
      if (this.showMainUnit && this.ware) return this.ware.main_unit_name;
      return undefined;
    },
    openInventory() {
      this.$refs.openInventoryBtn.openInventory();
    },
    setPrices() {
      if (this.hasSalePrices && this.ware && this.account) {
        if (this.account) {
          this.pricesFilters.factor__account = this.account.id;
          if (this.floatAccount) this.pricesFilters.factor__floatAccount = this.item.floatAccount.id;
          if (this.costCenter) this.pricesFilters.factor__costCenter = this.item.costCenter.id;
        }
        this.pricesFilters.ware = this.ware.id;
        this.pricesFilters.factor__type__in = this.factorType;
      }
    },
  },
  watch: {
    value() {
      this.setWare();
    },
    ware() {
      let ware = this.ware;
      if (ware && ware.id && !this.returnObject) ware = ware.id;
      this.$emit("input", ware);
      this.$emit("mainUnitName", this.ware.main_unit_name);
    },
  },
};
</script>

<style lang="scss">
.ware-select-autocomplete {
  input {
    direction: ltr;
    text-align: center !important;

    &[smaller-font] {
      font-size: 10px !important;
    }
  }
}

.v-list-item__title {
  font-size: 12px !important;
}

.v-list-item {
  min-height: 24px !important;
}
</style>
